export function interpolate(base, ...values) {
    let result = base;
    values.forEach((value, index) => {
        result = result.replace(`{${index}}`, value.toString());
    });
    return result;
}
